module.exports = __webpack_public_path__ + "static/media/flower-9.36f7e62b.svg";